/**
 * - `compact`: legacy Optimizely denser vertical tiles (`comms_compact_mobile_search_tile`).
 * - `cro-compact`: CRO-6924 horizontal mosaic rows (`cro-mobile-compact-search-tile`).
 */
export type SearchTileDensity = 'default' | 'compact' | 'cro-compact' | 'map-row' | 'map-card'
export type SearchTileTreatment = 'default' | 'featured-match'

/** ClassName density API for Search and MetaSearch tiles. */
export function getSearchTileDensityClassName(density: SearchTileDensity): string | undefined {
  if (density === 'cro-compact') return 'density-cro-compact'
  if (density === 'compact') return 'density-compact'
  return undefined
}

export function getSearchTileTreatmentClassName(treatment: SearchTileTreatment): string | undefined {
  if (treatment === 'featured-match') return 'treatment-featured-match'
  return undefined
}
